import React from 'react';
import './Map.css';

const Map = () => {
  // Vá ao Google Maps, pesquise o endereço da sua loja, clique em "Compartilhar" -> "Incorporar um mapa" e copie o src do iframe.
  const mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3748.502891636842!2d-44.09657000000001!3d-20.029368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa6c79ebf9b4267%3A0x8aafb8e0aa9d3628!2sMETROPOLITANA%20BATERIAS!5e0!3m2!1spt-BR!2sbr!4v1753751385318!5m2!1spt-BR!2sbr";

  return (
    <section className="map-section">
      <div className="container">
        <h2 className="section-title">Nossa Localização em Sarzedo - Região Metropolitana de Belo Horizonte</h2>
        <p className="map-subtitle">Venha nos visitar e tomar um café enquanto cuidamos do seu carro!</p>
        <div className="map-container">
          <iframe
            src={mapSrc}
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Localização da Baterias Metropolitana"
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default Map;